import NotificationsIcon from "@mui/icons-material/Notifications";
import { Badge, IconButton } from "@mui/material";
import { useGetIdentity, useGetList } from "react-admin";
import { Link } from "react-router-dom";

const NotificationsMenu = () => {
  const { identity } = useGetIdentity();
  const { total = 0 } = useGetList(
    "notifications",
    {
      pagination: { page: 1, perPage: 1 },
      sort: { field: "id", order: "DESC" },
      // Módulo 38 é o SCM
      filter: { nao_lidas: true, modulo: "SCM" },
    },
    { enabled: !!identity },
  );

  return (
    <IconButton
      color="inherit"
      component={Link}
      to="/notifications"
      aria-label="Notificações"
    >
      <Badge badgeContent={total} color="error" max={99} invisible={!total}>
        <NotificationsIcon />
      </Badge>
    </IconButton>
  );
};

export default NotificationsMenu;
